import { BRIGHTNESS_MODES } from "./installationBrightnessUtils";

export const BRIGHTNESS_RECOMMENDED_MODE = BRIGHTNESS_MODES.STANDARD;

export function getBrightnessModeLabel(t, mode) {
  if (mode === BRIGHTNESS_MODES.STANDARD) {
    return t("installation_brightness_mode_standard");
  }
  if (mode === BRIGHTNESS_MODES.HDR_AUTO) {
    return t("installation_brightness_mode_hdr_auto");
  }
  return t("installation_brightness_mode_contrast");
}

export function getBrightnessStatusKey(mode) {
  if (mode === BRIGHTNESS_MODES.STANDARD) {
    return "installation_brightness_status_standard";
  }
  if (mode === BRIGHTNESS_MODES.HDR_AUTO) {
    return "installation_brightness_status_hdr_auto";
  }
  return "installation_brightness_status_contrast";
}

const RECOMMENDED_MARKER_PERCENT = 33;

export function getBrightnessVisual(mode) {
  if (mode === BRIGHTNESS_MODES.STANDARD) {
    return {
      tone: "ok",
      fillPercent: 33,
      markerPercent: RECOMMENDED_MARKER_PERCENT,
    };
  }
  if (mode === BRIGHTNESS_MODES.HDR_AUTO) {
    return {
      tone: "warn",
      fillPercent: 66,
      markerPercent: RECOMMENDED_MARKER_PERCENT,
    };
  }
  return {
    tone: "neutral",
    fillPercent: 100,
    markerPercent: RECOMMENDED_MARKER_PERCENT,
  };
}
